import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../api/authApi";

export default function Login({ onClose }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear any previous error when user starts typing
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      await login(formData);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || "Login failed. Please check your credentials.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed z-10 inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex justify-center items-center">
      {/* Login Form Container */}
      <div
        className="w-[520px] rounded-md p-8 relative"
        style={{
          background: "linear-gradient(120deg, #FFFFFF 0%, #F0FDF4 100%)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        }}
      >
        {/* Close Button */}
        <button
          type="button"
          className="absolute top-4 right-4 text-xl text-gray-500 hover:text-black transition-all"
          onClick={onClose}
        >
          X
        </button>

        {/* Title */}
        <h1 className="text-2xl font-bold text-center my-3">Admin Login</h1>
        <p className="text-sm text-center w-[20rem] mx-auto font-thin mb-3">
          Login to access your account to manage your profile, view opportunities, and submit bids.
        </p>
        <hr />

        <form onSubmit={handleSubmit}>
          {/* Email Field */}
          <label htmlFor="email" className="block mt-4 font-bold">
            Email
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="example@gmail.com"
            className="w-full py-2 outline-none border-b-2 rounded-md text-sm font-thin"
            style={{
              backgroundColor: "#F9FAFB",
              borderColor: "#D1D5DB",
              padding: "10px",
            }}
            required
          />

          {/* Password Field */}
          <label htmlFor="password" className="block mt-4 font-bold">
            Password
          </label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Enter your password"
            className="w-full py-2 outline-none border-b-2 rounded-md text-sm font-thin"
            style={{
              backgroundColor: "#F9FAFB",
              borderColor: "#D1D5DB",
              padding: "10px",
            }}
            required
          />

          {/* Action Buttons */}
          <div className="form-button mt-10 flex justify-between items-center">
            {/* Forgot Password Link */}
            <Link
              to="/"
              className="text-sm underline"
              style={{ color: "black" }}
            >
              Forgot Password?
            </Link>

            {/* Login Button */}
            <button
              type="submit"
              className="px-5 py-2 rounded-full text-white"
              style={{
                backgroundColor: "black",
                color: "white",
                padding: "8px 20px",
                fontSize: "1rem",
                transition: "all 0.3s ease",
                opacity: isLoading ? 0.7 : 1,
                cursor: isLoading ? "not-allowed" : "pointer"
              }}
              disabled={isLoading}
            >
              {isLoading ? "Logging in..." : "Login"}
            </button>
          </div>
          {error && (
            <p className="text-red-500 text-sm mt-4 text-center">
              {error}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
